export default "__VITE_ASSET__gW$nMiBO__"